import { Directive, HostListener, Input } from '@angular/core';
import { IScrollToOptions, ScrollToService } from '@df/dom/scroll/scroll-to.service';

/**
 * Click event directive.
 *
 * ```html
 * <span [scrollTo]="'#someId'"></span>
 * ```
 */
@Directive({
    selector: '[scrollTo]',
    standalone: true
})
export class ScrollToDirective {
    @Input('scrollTo')
    target!: string | null | undefined;

    @Input('scrollToOptions')
    options?: Partial<IScrollToOptions>;

    constructor(private scrollToService: ScrollToService) {}

    /**
     * Listen the clicks.
     *
     * @param {Event} event
     * @memberof ClickEventAbstract
     */
    @HostListener('click', ['$event'])
    onClick(event: MouseEvent) {
        if (!this.target) {
            return;
        }
        this.scrollToService.scrollTo(this.target, this.options);
    }
}
